import { connect } from 'react-redux';

import Pager from 'ha/components/next/Pager';

import { changePage } from 'ha/pages/Search/actions';
import { getPagerProps } from 'ha/pages/Search/selectors';

export default connect(
  state => getPagerProps(state),
  {
    onPageChange: changePage,
  },
)(Pager);
